/* Auto Obrazy homepage interactions — cacheable static behaviour. */
'use strict';
(() => {
      const root = document.querySelector('.ao-home');
      if (!root || root.dataset.aoReady === 'true') return;
      root.dataset.aoReady = 'true';

      const revealItems = [...root.querySelectorAll('[data-ao-reveal]')];
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.04, rootMargin: '0px 0px 18% 0px' });
        revealItems.forEach((item) => revealObserver.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      const warmImages = [...root.querySelectorAll('.ao-custom-shirt__image, .ao-final-choice__photos img')];
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const image = entry.target;
            image.loading = 'eager';
            if ('fetchPriority' in image) image.fetchPriority = 'auto';
            if (typeof image.decode === 'function') image.decode().catch(() => {});
            observer.unobserve(image);
          });
        }, { rootMargin: '260px 0px', threshold: 0.01 });
        warmImages.forEach((image) => imageObserver.observe(image));
      }

      /* Judge.me ostáva jediným zdrojom recenzií. Ak jeho app blok/CDN
         zlyhá, nenecháme na stránke tiché prázdne miesto. */
      const judgeMeSlot = root.querySelector('.ao-judgeme-slot--home');
      const refreshJudgeMeFallback = () => {
        if (!judgeMeSlot) return;
        const fallback = judgeMeSlot.querySelector('[data-ao-judgeme-fallback]');
        const widget = judgeMeSlot.querySelector('.jdgm-widget, .jdgm-carousel-wrapper, .jdgm-cards, [class*="jdgm-card"]');
        const ready = Boolean(widget && widget.getClientRects().length && widget.textContent.trim());
        if (fallback) fallback.hidden = ready;
        judgeMeSlot.classList.toggle('is-judgeme-unavailable', !ready);
      };
      window.setTimeout(refreshJudgeMeFallback, 10000);
      window.setTimeout(refreshJudgeMeFallback, 18000);


      const realGallery = root.querySelector('[data-ao-real-gallery]');
      let galleryFocusObserver = null;
      if (realGallery && 'IntersectionObserver' in window) {
        galleryFocusObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => root.classList.toggle('is-gallery-focus', entry.isIntersecting));
        }, { rootMargin: '-8% 0px -8% 0px', threshold: 0.01 });
        galleryFocusObserver.observe(realGallery);
      }

      /* Virálne nálepky používajú natívny horizontálny scroll: dotyk je
         plynulý aj v Safari a šípky iba posúvajú o jednu kartu. */
      root.querySelectorAll('.ao-home-stickers').forEach((section) => {
        const stickerViewport = section.querySelector('[data-ao-sticker-viewport]');
        const stickerCards = [...section.querySelectorAll('.ao-home-sticker-card')];
        const stickerPrev = section.querySelector('[data-ao-sticker-prev]');
        const stickerNext = section.querySelector('[data-ao-sticker-next]');
        if (!stickerViewport || stickerCards.length < 1) return;

        const stickerReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const stickerStep = () => {
          const first = stickerCards[0];
          const track = first && first.parentElement;
          const styles = track ? window.getComputedStyle(track) : null;
          const gap = styles ? Number.parseFloat(styles.columnGap || styles.gap || '0') : 0;
          return Math.max(1, (first ? first.getBoundingClientRect().width : stickerViewport.clientWidth / 2) + gap);
        };
        const updateStickerArrows = () => {
          const max = Math.max(0, stickerViewport.scrollWidth - stickerViewport.clientWidth);
          if (stickerPrev) stickerPrev.disabled = stickerViewport.scrollLeft <= 2;
          if (stickerNext) stickerNext.disabled = stickerViewport.scrollLeft >= max - 2;
        };
        const moveStickers = (direction) => stickerViewport.scrollBy({
          left: stickerStep() * direction,
          behavior: stickerReducedMotion ? 'auto' : 'smooth',
        });

        stickerPrev?.addEventListener('click', () => moveStickers(-1));
        stickerNext?.addEventListener('click', () => moveStickers(1));
        stickerViewport.addEventListener('scroll', updateStickerArrows, { passive: true });
        stickerViewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          moveStickers(event.key === 'ArrowLeft' ? -1 : 1);
        });
        window.addEventListener('resize', updateStickerArrows, { passive: true });
        updateStickerArrows();
      });

      /* FIX 213 — pás tričiek. Rovnaké ovládanie ako carousel nálepiek:
         natívny scroll (plynulý dotyk aj v Safari) a šípky o jeden stĺpec.
         Nič sa nehýbe samo — žiadny autoplay, žiadna CSS animácia. */
      root.querySelectorAll('[data-ao-shirt-loop]').forEach((loop) => {
        const shirtViewport = loop.querySelector('[data-ao-shirt-viewport]');
        const shirtCols = [...loop.querySelectorAll('.ao-shirt-loop__col')];
        const shirtPrev = loop.querySelector('[data-ao-shirt-prev]');
        const shirtNext = loop.querySelector('[data-ao-shirt-next]');
        if (!shirtViewport || shirtCols.length < 1) return;

        const shirtReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const shirtStep = () => {
          const first = shirtCols[0];
          const styles = window.getComputedStyle(first);
          const marginRight = Number.parseFloat(styles.marginRight || '0') || 0;
          return Math.max(1, first.getBoundingClientRect().width + marginRight);
        };
        const updateShirtArrows = () => {
          const max = Math.max(0, shirtViewport.scrollWidth - shirtViewport.clientWidth);
          if (shirtPrev) shirtPrev.disabled = shirtViewport.scrollLeft <= 2;
          if (shirtNext) shirtNext.disabled = shirtViewport.scrollLeft >= max - 2;
        };
        const moveShirts = (direction) => shirtViewport.scrollBy({
          left: shirtStep() * direction,
          behavior: shirtReducedMotion ? 'auto' : 'smooth',
        });

        shirtPrev?.addEventListener('click', () => moveShirts(-1));
        shirtNext?.addEventListener('click', () => moveShirts(1));
        shirtViewport.addEventListener('scroll', updateShirtArrows, { passive: true });
        shirtViewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          moveShirts(event.key === 'ArrowLeft' ? -1 : 1);
        });
        window.addEventListener('resize', updateShirtArrows, { passive: true });
        updateShirtArrows();
      });
    })();
